/* eslint-disable */
import Oidc, { User } from 'oidc-client';
import { alarm, profile } from '@/store';
import {
    createOidcAuth,
    LogLevel,
    OidcAuth,
    SignInType,
} from 'vue-oidc-client/vue2';
import addSeconds from 'date-fns/addSeconds';
const loco = window.location;
const appRootUrl = `${loco.protocol}//${loco.host}${process.env.BASE_URL}`;
import { configureMessageHub } from '@/plugins/messageHub';
import { Log } from '@/plugins/Logging';
let authObj = null as OidcAuth | null;

export async function configureOidc() {
    if (authObj) return Promise.resolve(authObj);

    const configFetch = await fetch('/_configuration/MarineOneApp');
    const config = await configFetch.json();

    authObj = createOidcAuth(
        'main',
        SignInType.Window,
        appRootUrl,
        {
            ...config,
            // test use
            prompt: 'login',

            // max_age: 120,
            // automaticSilentRenew: true,
            start_checksession: true,
            silent_renew: true,
            silent_redirect_uri: `${appRootUrl}/silent-refresh.html`,
            log_console_warning_active: true,
            log_console_debug_active: false,
        },
        console,
        LogLevel.Debug
    );

    // handle events
    authObj.events.addAccessTokenExpiring(function () {
        if (authObj) {
            authObj.startSilentRenew();
        } else {
            window.location.href = appRootUrl;
        }
    });
    authObj.events.addAccessTokenExpired(function () {
        alarm.ClearAlarmData();
        if (authObj) {
            authObj.signOut().then(() => {
                window.location.href = appRootUrl;
            });
        } else {
            window.location.href = appRootUrl;
        }
    });

    authObj.events.addSilentRenewError(function (err: Error) {
        alarm.ClearAlarmData();
    });

    authObj.events.addUserLoaded(function (user: User) {
        if (authObj) {
            authObj.startSilentRenew();
        }
        profile.Get().then(() => {
            configureMessageHub().then(() => {
                Log.information('Messagehub started');
            });
        });
    });

    authObj.events.addUserUnloaded(function () {
        alarm.ClearAlarmData();
        window.location.href = appRootUrl;
    });

    authObj.events.addUserSignedOut(function () {
        window.location.href = appRootUrl;
    });

    authObj.events.addUserSessionChanged(function () {
        alarm.ClearAlarmData();
    });
    const getExpirationTime = (expires_At: number): Date => {
        var jan1970 = new Date('1970-01-01T00:00:00Z');
        return addSeconds(jan1970, expires_At);
    };
    return authObj;
}
